import head from "lodash/fp/head";
import flow from "lodash/fp/flow";
import isNil from "lodash/fp/isNil";
import identity from "lodash/fp/identity";
import capitalize from "lodash/fp/capitalize";
import moment from "moment";
import constants from "../../core/constants";
import { toObject, parsePrice } from "../../core/utils";

class LoanPageTransform {
  constructor() {
    "ngInject";

    this.invoiceItemFields = [
      { name: "date", title: "Date" },
      { name: "amount", title: "Amount" },
      { name: "type", title: "Type" },
      { name: "active", title: "Active" },
      { name: "operator", title: "Operator" },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.type = capitalize(item.type);
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.upcomingInstallments =
        item.next_installments.length > 0
          ? head(item.next_installments).amount
          : null;
      item.next_installments =
        item.next_installments.length > 0
          ? moment(head(item.next_installments).date).format(
              constants.dateTimeFormat
            )
          : null;
      item.isFinalized = isNil(item.next_installments);
      item.total_amount = parsePrice(item.total_amount);
      item.remaining_amount = parsePrice(item.remaining_amount);
      item.upcomingInstallments = parsePrice(item.upcomingInstallments);

      return item;
    };

    return toObject(flow([format, identity])(data));
  }
}

export default LoanPageTransform;



// WEBPACK FOOTER //
// ./src/pages/loan/loan.transforms.js